import React, { useState, useRef, useEffect } from 'react';

export default function HorseGallery({ images = [] }) {
  const [selectedImageIndex, setSelectedImageIndex] = useState(0);
  const [lightboxOpen, setLightboxOpen] = useState(false);

  const touchStartX = useRef(null);
  const touchEndX = useRef(null);

  const handleTouchStart = (e) => {
    touchStartX.current = e.targetTouches[0].clientX;
  };

  const handleTouchMove = (e) => {
    touchEndX.current = e.targetTouches[0].clientX;
  };

  const handleTouchEnd = () => {
    if (!touchStartX.current || !touchEndX.current) return;
    const diff = touchStartX.current - touchEndX.current;
    if (Math.abs(diff) > 50) {
      if (diff > 0) {
        setSelectedImageIndex((prev) => Math.min(prev + 1, images.length - 1));
      } else {
        setSelectedImageIndex((prev) => Math.max(prev - 1, 0));
      }
    }
    touchStartX.current = null;
    touchEndX.current = null;
  };

  // Optional: Desktop arrow key support (currently commented out)
  /*
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (!lightboxOpen) return;
      if (e.key === 'ArrowLeft') {
        setSelectedImageIndex((prev) => Math.max(prev - 1, 0));
      } else if (e.key === 'ArrowRight') {
        setSelectedImageIndex((prev) => Math.min(prev + 1, images.length - 1));
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [lightboxOpen, images.length]);
  */

  return (
    <div className="flex flex-col gap-3 mb-4">
      {/* Main Image */}
      <div
        className="w-full border rounded overflow-hidden cursor-zoom-in"
        onClick={() => setLightboxOpen(true)}
      >
        <img
          src={images[selectedImageIndex]}
          alt="Selected Horse"
          className="w-full h-96 object-contain rounded"
        />
      </div>

      {/* Thumbnails */}
      <div className="flex overflow-x-auto gap-2 justify-center">
        {images.map((src, i) => (
          <img
            key={i}
            src={src}
            alt={`Thumbnail ${i + 1}`}
            onClick={() => setSelectedImageIndex(i)}
            className={`h-20 w-28 object-cover rounded cursor-pointer border-2 ${
              selectedImageIndex === i ? 'border-primary' : 'border-transparent'
            }`}
          />
        ))}
      </div>

      {/* Lightbox Modal */}
      {lightboxOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-80 z-50 flex items-center justify-center"
          onClick={() => setLightboxOpen(false)}
        >
          <div
            className="relative max-w-4xl w-full px-4"
            onClick={(e) => e.stopPropagation()}
            onTouchStart={handleTouchStart}
            onTouchMove={handleTouchMove}
            onTouchEnd={handleTouchEnd}
          >
            <button
              onClick={() => setLightboxOpen(false)}
              className="absolute top-4 right-4 text-white text-3xl font-bold"
            >
              ×
            </button>
            <img
              src={images[selectedImageIndex]}
              alt="Zoomed Horse"
              className="w-full max-h-[80vh] object-contain rounded"
            />
          </div>
        </div>
      )}
    </div>
  );
}